<template>
  <v-app-bar app color="white" height="100">
    <!-- Dynamically rendered section based on current route -->

    <div v-if="routeDependentClass === 'home-class' && !isMobile && isScrolled">
      <span class="font-weight-black black--text custom-font display-1">
        EXECUTIVE MAINTENANCE
      </span>
      <span class="font-weight-black red--text custom-font display-1">
        SERVICES INC
      </span>
    </div>
    <div
      v-if="routeDependentClass !== 'home-class' && !isMobile"
      :class="routeDependentClass"
    >
      <span class="font-weight-black black--text custom-font display-1">
        {{ routeDependentTextLine1 }}
      </span>
      <span
        :class="[
          'font-weight-black',
          'custom-font',
          'display-1',
          routeDependentClass === 'construction-class'
            ? 'gold-text'
            : 'red--text',
        ]"
      >
        {{ routeDependentTextLine2 }}
      </span>
    </div>
    <!-- Your existing code or other elements -->
    <v-spacer></v-spacer>

    <v-btn-toggle
      v-model="toggle"
      group
      :style="
        routeDependentClass === 'construction-class'
          ? 'color: #CCAC00'
          : 'color: red'
      "
    >
      <v-btn text @click="navigateRoute('/', 'home')">Home</v-btn>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">Services</v-btn>
        </template>
        <v-list>
          <v-list-item link @click="navigateRoute('/', 'services')">
            <v-list-item-icon>
              <v-icon color="black">mdi-view-dashboard</v-icon>
              <!-- Replace with your preferred icon -->
            </v-list-item-icon>
            <v-list-item-content>Overview</v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            @click="navigateRoute('/services_maintenance', 'top')"
          >
            <v-list-item-icon>
              <v-icon color="red darken-1">mdi-wrench</v-icon>
              <!-- Replace with your preferred icon -->
            </v-list-item-icon>
            <v-list-item-content>Building Maintenance</v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            @click="navigateRoute('/services_disaster_relief', 'top')"
          >
            <v-list-item-icon>
              <v-icon color="red darken-1">mdi-hazard-lights</v-icon>
              <!-- Replace with your preferred icon -->
            </v-list-item-icon>
            <v-list-item-content>Disaster Relief</v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            @click="navigateRoute('/services_construction', 'top')"
          >
            <v-list-item-icon>
              <img
                src="@/assets/ems_images/werek_construction.png"
                class="icon-image"
                alt="Construction"
              />
            </v-list-item-icon>
            <v-list-item-content>Werek Construction</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn text @click="navigateRoute('/about', 'about')">About</v-btn>
      <v-btn text @click="navigateRoute('/contact', 'contact')">Contact</v-btn>
    </v-btn-toggle>
  </v-app-bar>
</template>
  
  
<script>
import { mapGetters } from "vuex";

export default {
  name: "AppBar",
  data() {
    return {
      isScrolled: false,
      toggle: null,
      routeDetails: {
        "/": {
          class: "home-class",
          line1: "EXECUTIVE MAINTENANCE",
          line2: "SERVICES INC",
        },
        "/services_maintenance": {
          class: "services-class",
          line1: "BUILDING",
          line2: "MAINTENANCE",
        },
        "/services_disaster_relief": {
          class: "disaster_relief-class",
          line1: "DISASTER",
          line2: "RELIEF",
        },
        "/services_construction": {
          class: "construction-class",
          line1: "WEREK",
          line2: "CONSTRUCTION",
        },
        // default or other routes can be defined similarly
        default: {
          class: "default-class",
          line1: "",
          line2: "",
        },
      },
    };
  },

  computed: {
    ...mapGetters(["isMobile"]),

    routeDependentClass() {
      return (
        this.routeDetails[this.$route.path] || this.routeDetails["default"]
      ).class;
    },
    routeDependentTextLine1() {
      return (
        this.routeDetails[this.$route.path] || this.routeDetails["default"]
      ).line1;
    },
    routeDependentTextLine2() {
      return (
        this.routeDetails[this.$route.path] || this.routeDetails["default"]
      ).line2;
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 0; // Check if page is scrolled
    },

    navigateRoute(route, section) {
      if (this.$route.path === route) {
        this.$vuetify.goTo("#" + section);
      } else {
        this.$router.push(route).then(() => {
          this.$nextTick(() => {
            // Wait for the next DOM update cycle
            this.$vuetify.goTo("#" + section);
          });
        });
      }
    },
  },
};
</script>
  
<style scoped>
.mobile-toolbar {
  margin-top: 500px; /* Offset by the height of v-app-bar */
}
.gold-text {
  color: #ccac00; /* Darker gold color */
}

.icon-image {
  width: 24px; /* or any other size */
  height: 24px;
}
</style>
  